var products_filter_loading_template = '';